import type { Props as TypographyProps } from 'src/components/ui/Typography';
import Typography from 'src/components/ui/Typography';
import { styledComponent } from 'src/utils/styled';

import theme from 'src/utils/theme';

interface LinkButtonProps extends TypographyProps {
    as?: string;
}

const LinkButton = styledComponent(Typography)<LinkButtonProps>`
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
    color: ${theme.palette.primary.main};
`;

export default LinkButton;
